/* AUREMAR theme behaviour, sidebar, product variants, special request.
   No dependencies, no build step. */
(function () {
  'use strict';

  /* ------------------------------------------------------------- loader */
  var loader = document.getElementById('AuremarLoader');
  if (loader) {
    var hide = function () {
      setTimeout(function () {
        loader.classList.add('done');
      }, 380);
    };
    if (document.readyState === 'complete') hide();
    else {
      window.addEventListener('load', hide, { once: true });
      setTimeout(function () {
        loader.classList.add('done');
      }, 2600);
    }
  }

  /* --------------------------------------------------- announcement bar */
  /* The shipping bar belongs to the top of the page, not to the viewport: it
     slides away with the first 38px of scroll and the top bar closes up behind
     it. One CSS variable drives both, so they move in a single paint. */
  (function () {
    var root = document.documentElement;
    if (!document.querySelector('.announce')) return;
    var height = function () {
      return parseFloat(getComputedStyle(root).getPropertyValue('--announce-h')) || 38;
    };
    var frame = 0;
    function apply() {
      frame = 0;
      var y = Math.min(Math.max(window.scrollY || window.pageYOffset || 0, 0), height());
      root.style.setProperty('--announce-shift', y + 'px');
    }
    apply();
    window.addEventListener('scroll', function () {
      if (!frame) frame = window.requestAnimationFrame(apply);
    }, { passive: true });
  })();

  /* ------------------------------------------------------------ sidebar */
  var sidebar = document.getElementById('AuremarSidebar');
  var scrim = document.getElementById('AuremarScrim');
  var menuBtn = document.getElementById('AuremarMenuBtn');
  var menuClose = document.getElementById('AuremarMenuClose');

  function setMenu(open) {
    if (!sidebar) return;
    sidebar.classList.toggle('open', open);
    if (scrim) scrim.classList.toggle('open', open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', String(open));
    if (open) sidebar.removeAttribute('inert');
    else sidebar.setAttribute('inert', '');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', function () {
      setMenu(!sidebar.classList.contains('open'));
    });
  }
  if (menuClose) menuClose.addEventListener('click', function () { setMenu(false); });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });

  /* ------------------------------------------------------------- search */
  /* Predictive search against Shopify's own /search/suggest endpoint, so the
     results are always whatever the store actually has published. The form
     underneath is a plain GET, which keeps search working without JS. */
  (function () {
    var panel = document.getElementById('AuremarSearchPanel');
    var openBtn = document.getElementById('AuremarSearchBtn');
    if (!panel || !openBtn) return;

    var input = document.getElementById('AuremarSearchInput');
    var form = document.getElementById('AuremarSearchForm');
    var closeBtn = document.getElementById('AuremarSearchClose');
    var results = document.getElementById('AuremarSearchResults');
    var suggest = document.getElementById('AuremarSearchSuggest');
    var allLink = document.getElementById('AuremarSearchAll');
    var searchUrl = (allLink && allLink.getAttribute('href')) || '/search';
    var active = -1;
    var token = 0;
    var timer = 0;

    function setSearch(open) {
      panel.classList.toggle('open', open);
      if (scrim) scrim.classList.toggle('open', open);
      openBtn.setAttribute('aria-expanded', String(open));
      if (open) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        setMenu(false);
        setTimeout(function () { if (input) input.focus(); }, 60);
      } else if (input) {
        input.value = '';
        render([], '');
      }
    }

    function rows() {
      return results ? Array.prototype.slice.call(results.querySelectorAll('.search-hit')) : [];
    }

    function highlight(i) {
      var list = rows();
      if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (el, n) {
        el.classList.toggle('is-active', n === active);
        if (n === active && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      });
    }

    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function kindOf(item) {
      if (item.__kind) return item.__kind;
      return 'Result';
    }

    function render(items, term) {
      if (!results) return;
      active = -1;
      if (suggest) suggest.hidden = !!term;
      if (allLink) {
        allLink.hidden = !term || !items.length;
        allLink.href = searchUrl + '?q=' + encodeURIComponent(term);
        allLink.textContent = 'See all results for \u201C' + term + '\u201D';
      }

      if (!term) { results.innerHTML = ''; return; }

      if (!items.length) {
        results.innerHTML =
          '<p class="search-empty">Nothing matches <strong>' + esc(term) +
          '</strong>. Try a piece name (Arco, Nexo, Kubo), a stone (Rosso Levanto, Tandra Grey) ' +
          'or a topic like shipping or payment.</p>';
        return;
      }

      results.innerHTML = items.map(function (item) {
        var img = item.image
          ? '<img src="' + esc(item.image) + '" alt="" width="96" height="96" loading="lazy">'
          : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="1.6" stroke-linecap="round" aria-hidden="true">' +
            '<circle cx="11" cy="11" r="7"></circle><path d="m16.4 16.4 4.1 4.1"></path></svg>';
        return (
          '<a class="search-hit" role="option" href="' + esc(item.url) + '">' +
            '<span class="search-hit__thumb">' + img + '</span>' +
            '<span class="search-hit__text">' +
              '<span class="search-hit__title">' + esc(item.title) + '</span>' +
              '<span class="search-hit__sub">' + esc(item.subtitle) + '</span>' +
            '</span>' +
            '<span class="search-hit__kind">' + esc(kindOf(item)) + '</span>' +
          '</a>'
        );
      }).join('');
    }

    function normalise(data) {
      var r = (data && data.resources && data.resources.results) || {};
      var out = [];

      (r.products || []).forEach(function (p) {
        out.push({
          url: p.url,
          title: p.title,
          subtitle: p.price ? 'From ' + p.price : (p.vendor || 'AUREMAR'),
          image: p.featured_image && p.featured_image.url,
          __kind: 'Piece'
        });
      });
      (r.collections || []).forEach(function (c) {
        out.push({ url: c.url, title: c.title, subtitle: 'Collection', image: null, __kind: 'Collection' });
      });
      (r.pages || []).forEach(function (pg) {
        out.push({ url: pg.url, title: pg.title, subtitle: 'Page', image: null, __kind: 'Page' });
      });
      (r.articles || []).forEach(function (a) {
        out.push({ url: a.url, title: a.title, subtitle: 'Journal', image: a.image && a.image.url, __kind: 'Journal' });
      });

      return out.slice(0, 12);
    }

    function query(term) {
      var mine = ++token;
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,page,collection,article&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (mine !== token) return; /* a newer keystroke already won */
          render(normalise(data), term);
        })
        .catch(function () {
          if (mine !== token) return;
          render([], term);
        });
    }

    openBtn.addEventListener('click', function () {
      setSearch(!panel.classList.contains('open'));
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setSearch(false); });
    if (scrim) scrim.addEventListener('click', function () { setSearch(false); });

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (!term) { render([], ''); return; }
        timer = setTimeout(function () { query(term); }, 160);
      });

      input.addEventListener('keydown', function (e) {
        var list = rows();
        if (e.key === 'Escape') { setSearch(false); return; }
        if (e.key === 'ArrowDown' && list.length) { e.preventDefault(); highlight(active + 1); }
        else if (e.key === 'ArrowUp' && list.length) { e.preventDefault(); highlight(active - 1); }
        else if (e.key === 'Enter' && active > -1 && list[active]) {
          e.preventDefault();
          window.location.href = list[active].getAttribute('href');
        }
        /* Enter with nothing highlighted submits the form to /search. */
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!input || !input.value.trim()) e.preventDefault();
      });
    }

    document.querySelectorAll('[data-search-suggest]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!input) return;
        input.value = chip.textContent.trim();
        input.focus();
        query(input.value);
      });
    });

    document.addEventListener('keydown', function (e) {
      var el = document.activeElement;
      var typing = el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
      if ((e.metaKey || e.ctrlKey) && String(e.key).toLowerCase() === 'k') {
        e.preventDefault();
        setSearch(true);
      } else if (e.key === '/' && !typing) {
        e.preventDefault();
        setSearch(true);
      } else if (e.key === 'Escape') {
        setSearch(false);
      }
    });
  })();

/* ------------------------------------------------------ footer columns */
  /* Collapsible on a phone; the CSS keeps them open on a wide screen. */
  document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var col = btn.closest('.footer__col--acc');
      var open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* -------------------------------------------------- before/after slider */
  /* Movement before a press turns into a drag, so a tap never nudges the wipe. */
  var BA_DRAG_SLOP = 3;
  /* A press that stays inside this box, for this long, counts as a tap. */
  var BA_TAP_MOVE = 6;
  var BA_TAP_MS = 300;
  /* How far past the end of the wipe you pull before the row moves on. */
  var BA_OVERPULL = 58;
  /* How much of that pull shows as give in the card. */
  var BA_RUBBER = 0.22;
  var BA_RUBBER_MAX = 26;

  /* Three ways to work a card, and none of them fight each other:
       drag   wipes the photograph, at any speed
       tap    springs to whichever side you are not looking at
       pull   past either end, and the row moves on to the next piece
     Speed deliberately means nothing here. Judging a wipe by how fast it moves
     makes an ordinary drag read as a page turn, so the two gestures are kept
     apart by where they end instead. */
  document.querySelectorAll('[data-ba]').forEach(function (frame) {
    var after = frame.querySelector('.ba__after');
    var handle = frame.querySelector('.ba__handle');
    var range = frame.querySelector('.ba__range');
    var card = frame.closest('.ba');

    var dragging = false;
    var wiping = false;
    var box = null;
    var startX = 0;
    var startT = 0;
    var pct = 50;
    /* The furthest the drag was pulled past either end. Read once, on release. */
    var pull = 0;

    function set(next, glide) {
      var v = Math.min(100, Math.max(0, next));
      pct = v;
      frame.classList.toggle('is-gliding', Boolean(glide));
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      handle.style.left = v + '%';
      if (range) range.value = Math.round(v);
    }

    /* Is there a card to move to in this direction, and a row that can scroll? */
    function canStep(direction) {
      var row = card && card.closest('.ba-row');
      if (!card || !row || row.scrollWidth <= row.clientWidth + 4) return false;
      return Boolean(direction === 1 ? card.nextElementSibling : card.previousElementSibling);
    }

    /* The give you feel when the wipe has nowhere left to go. Only offered when
       there is actually a card to pull towards: at the end of the row the give
       would promise a move that cannot happen, and shifting the last card also
       drags the row's own scroll position with it. */
    function rubber(px) {
      var give = px && canStep(px < 0 ? 1 : -1)
        ? Math.max(-BA_RUBBER_MAX, Math.min(BA_RUBBER_MAX, px * BA_RUBBER))
        : 0;
      frame.style.transform = give ? 'translateX(' + give + 'px)' : '';
    }

    /* Moves the row one card along. Returns false when there is nowhere to go,
       or when the row is not scrolling at all, which is the case on a wide
       screen where every card is already in view. */
    function step(direction) {
      var row = card && card.closest('.ba-row');
      if (!card || !row) return false;
      if (row.scrollWidth <= row.clientWidth + 4) return false;

      var target = direction === 1 ? card.nextElementSibling : card.previousElementSibling;
      if (!target) return false;

      var rowBox = row.getBoundingClientRect();
      var targetBox = target.getBoundingClientRect();
      var left =
        row.scrollLeft + (targetBox.left - rowBox.left) - (row.clientWidth - targetBox.width) / 2;
      row.scrollTo({ left: left, behavior: 'smooth' });
      return true;
    }

    /* Re-reads the frame box. The row can still be gliding when a drag starts. */
    function remeasure() { box = frame.getBoundingClientRect(); }

    function release() {
      dragging = false;
      wiping = false;
      pull = 0;
      box = null;
      var r0 = card && card.closest('.ba-row');
      if (r0) r0.removeEventListener('scroll', remeasure);
      frame.classList.remove('is-dragging');
      frame.classList.add('is-gliding');
      frame.style.transform = '';
    }

    frame.addEventListener('pointerdown', function (e) {
      dragging = true;
      wiping = false;
      pull = 0;
      box = frame.getBoundingClientRect();
      // If the row is still gliding from a previous step, the box moves out
      // from under the drag. Follow it, or the wipe drifts and a plain drag can
      // read as a pull past the end.
      var rowEl = card && card.closest('.ba-row');
      if (rowEl) rowEl.addEventListener('scroll', remeasure, { passive: true });
      startX = e.clientX;
      startT = e.timeStamp;
      try { frame.setPointerCapture(e.pointerId); } catch (err) { /* drag still works */ }
    });

    frame.addEventListener('pointermove', function (e) {
      if (!dragging || !box) return;

      var dx = e.clientX - startX;
      // Nothing moves until the press has clearly become a drag, so a tap never
      // leaves the wipe somewhere the visitor did not put it.
      if (!wiping) {
        if (Math.abs(dx) < BA_DRAG_SLOP) return;
        wiping = true;
        frame.classList.add('is-dragging');
      }

      var raw = ((e.clientX - box.left) / box.width) * 100;
      set(raw);

      // Past either end the wipe has nothing left to give, so the pull starts
      // counting towards the next piece instead.
      var over = 0;
      if (raw > 100) over = ((raw - 100) / 100) * box.width;
      else if (raw < 0) over = (raw / 100) * box.width;
      // Recorded now, acted on when the finger lifts. Nothing interrupts the
      // drag itself: it tracks the finger until it is let go.
      if (Math.abs(over) > Math.abs(pull)) pull = over;
      rubber(over);
    }, { passive: true });

    frame.addEventListener('pointerup', function (e) {
      var tapped =
        !wiping &&
        Math.abs(e.clientX - startX) < BA_TAP_MOVE &&
        e.timeStamp - startT < BA_TAP_MS;

      // A tap is the whole gesture for anyone who does not want to drag: it
      // springs to whichever side is not currently showing.
      if (tapped) set(pct > 50 ? 0 : 100, true);
      // Pulling left runs out of "after" and brings the next card in. The wipe
      // also has to have finished hard against that end, so a drag that merely
      // passed through cannot move the row.
      else if (Math.abs(pull) > BA_OVERPULL && (pull < 0 ? pct <= 0.5 : pct >= 99.5)) {
        step(pull < 0 ? 1 : -1);
      }
      release();
    });

    frame.addEventListener('pointercancel', release);
    if (range) range.addEventListener('input', function () { set(Number(range.value)); });
  });

  /* ------------------------------------------------------------ order flow */
  /* On a phone the steps follow the scroll, the visitor drives the sequence
     instead of racing a timer. On a wide screen it plays through slowly. */
  (function () {
    var section = document.getElementById('AuremarOrderFlow');
    if (!section) return;
    var steps = section.querySelectorAll('.flow__step');
    if (!steps.length) return;

    function paint(active) {
      steps.forEach(function (el, i) {
        el.classList.toggle('is-on', i <= active);
        el.classList.toggle('is-active', i === active);
      });
    }
    steps.forEach(function (el, i) {
      el.querySelector('.flow__dot').addEventListener('click', function () { paint(i); });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      paint(steps.length - 1);
      return;
    }

    if (window.matchMedia('(max-width: 760px)').matches) {
      var frame = 0;
      var onScroll = function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          var r = section.getBoundingClientRect();
          var progress = (window.innerHeight * 0.6 - r.top) / (r.height || 1);
          paint(Math.min(steps.length - 1, Math.max(0, Math.round(progress * (steps.length - 1)))));
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }

    paint(0);
    var started = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || started) return;
      started = true;
      var i = 0;
      var tick = setInterval(function () {
        i += 1;
        if (i >= steps.length) { clearInterval(tick); return; }
        paint(i);
      }, 2400);
    }, { threshold: 0.35 });
    io.observe(section);
  })();

/* --------------------------------------------------- WhatsApp checkout */
  /* The cart, written out as a message. The customer presses send. */
  (function () {
    var btn = document.getElementById('WaOrder');
    var dataEl = document.getElementById('WaOrderData');
    if (!btn || !dataEl) return;
    var data = JSON.parse(dataEl.textContent);

    btn.addEventListener('click', function () {
      var name = (document.getElementById('WaName').value || '').trim();
      var phone = (document.getElementById('WaPhone').value || '').trim();
      var err = document.getElementById('WaError');
      if (!name || !phone) {
        if (err) err.hidden = false;
        return;
      }
      if (err) err.hidden = true;

      // WhatsApp renders *asterisks* as bold.
      var lines = ['*AUREMAR · ORDER*', '', '*Name:* ' + name, '*Phone:* ' + phone];
      if (data.note) lines.push('*Notes:* ' + data.note);
      lines.push('', '*My order*');
      data.items.forEach(function (i) {
        lines.push(
          '• ' + i.title + ', ' + i.variant +
            (i.dimensions ? ' (' + i.dimensions + ')' : '') +
            ' × ' + i.qty + ', ' + i.line
        );
      });
      lines.push(
        '',
        '*Total:* ' + data.total,
        '*Deposit now (' + data.pct + '%):* ' + data.deposit,
        '*On delivery:* ' + data.balance + ', cash or InstaPay',
        '*Delivery:* free in ' + data.zones + ' (' + data.lead + ')',
        '',
        'Please confirm my order.'
      );

      window.open(
        'https://wa.me/' + btn.dataset.phone.replace(/[^0-9]/g, '') +
          '?text=' + encodeURIComponent(lines.join('\n')),
        '_blank',
        'noopener'
      );
    });
  })();

  /* ------------------------------------------------------------ reveals */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px' }
      );
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------- product page */
  var root = document.getElementById('ProductRoot');
  if (root) initProduct(root);

  function initProduct(root) {
    var dataEl = document.getElementById('VariantData');
    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var selected = [];
    root.querySelectorAll('.variant.active').forEach(function (btn) {
      selected[Number(btn.dataset.optionIndex)] = btn.dataset.value;
    });

    var main = document.getElementById('GalleryMain');

    // Thumbnails. Re-bound whenever the strip is rebuilt for a new marble.
    function bindThumbs() {
      root.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          root.querySelectorAll('.gallery__thumb').forEach(function (t) {
            t.classList.remove('active');
          });
          thumb.classList.add('active');
          if (main) main.src = thumb.dataset.full;
        });
      });
    }
    bindThumbs();

    // Option buttons.
    root.querySelectorAll('.variant').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.dataset.optionIndex);
        selected[idx] = btn.dataset.value;
        root
          .querySelectorAll('.variant[data-option-index="' + idx + '"]')
          .forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('active', on);
            b.setAttribute('aria-pressed', String(on));
          });
        apply();
      });
    });

    function apply() {
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) {
          return selected[i] === undefined || selected[i] === o;
        });
      });
      if (!match) return;

      set('VariantId', match.id, 'value');
      text('PriceDisplay', match.price);
      text('DepositDisplay', (window.AUREMAR.depositPct || 50) + '% deposit today, ' + match.deposit);
      text('MarbleName', match.marble);
      text('MarbleStory', match.story);
      text('MarbleCare', match.care);
      text('SpecMarble', match.marble);
      text('CareMarble', match.marble);
      text('SpecOrigin', match.origin);

      var add = document.getElementById('AddToCart');
      if (add) {
        add.disabled = !match.available;
        add.textContent = match.available ? 'Add to cart' : 'Unavailable';
      }

      /* Rebuild the gallery for the chosen marble. The thumbs belong to the
         selected stone only, which is how the Vercel build behaves; without
         this the strip kept every stone's photography on screen at once. */
      var thumbs = document.getElementById('GalleryThumbs');
      var shots = match.shots || [];
      if (thumbs) {
        if (shots.length > 1) {
          thumbs.innerHTML = shots.map(function (sh, i) {
            return '<button class="gallery__thumb' + (i === 0 ? ' active' : '') + '"' +
              ' data-full="' + sh.full + '" aria-label="View image ' + (i + 1) + '">' +
              '<img src="' + sh.thumb + '" alt="" width="74" height="92" loading="lazy"></button>';
          }).join('');
          thumbs.hidden = false;
          bindThumbs();
        } else {
          thumbs.innerHTML = '';
          thumbs.hidden = true;
        }
      }
      if (main) main.src = (shots[0] && shots[0].full) || match.image || main.src;

      var link = document.getElementById('VisualizerLink');
      if (link) {
        link.href = link.href.split('?')[0] +
          '?product=' + encodeURIComponent(root.dataset.productUrl.split('/').pop()) +
          '&marble=' + encodeURIComponent(match.marble);
      }

      // Keep the address bar honest so the variant can be shared.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    function text(id, value) {
      var el = document.getElementById(id);
      if (el && value != null) el.textContent = value;
    }
    function set(id, value, prop) {
      var el = document.getElementById(id);
      if (el) el[prop] = value;
    }
  }

  /* ------------------------------------------------- customize page form */
  var czMarble = document.getElementById('cz-marble');
  var czOther = document.getElementById('cz-other');
  if (czMarble && czOther) {
    czMarble.addEventListener('change', function () {
      var isOther = czMarble.value === 'Other';
      czOther.hidden = !isOther;
      czOther.required = isOther;
    });
  }

  /* -------------------------------------------------- special request */
  var srModal = document.getElementById('SpecialRequestModal');
  var srOpen = document.getElementById('SpecialRequestOpen');
  var srClose = document.getElementById('SpecialRequestClose');

  function setModal(open) {
    if (!srModal) return;
    srModal.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (srOpen) srOpen.addEventListener('click', function () { setModal(true); });
  if (srClose) srClose.addEventListener('click', function () { setModal(false); });
  if (srModal) {
    srModal.addEventListener('click', function (e) {
      if (e.target === srModal) setModal(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setModal(false);
    });

    // Reveal the free-text field only when "Other" is chosen, and make it
    // required so the request is never ambiguous.
    var marbleSel = document.getElementById('sr-marble');
    var other = document.getElementById('sr-other');
    if (marbleSel && other) {
      marbleSel.addEventListener('change', function () {
        var isOther = marbleSel.value === 'Other';
        other.hidden = !isOther;
        other.required = isOther;
      });
    }

    // Review step: compose the message, show it, and only then allow sending.
    var form = document.getElementById('SpecialRequestForm');
    var reviewBtn = document.getElementById('SpecialRequestReview');
    var sendBtn = document.getElementById('SpecialRequestSend');
    var editBtn = document.getElementById('SpecialRequestEditIcon');
    var preview = document.getElementById('SpecialRequestPreview');
    var summaryEl = document.getElementById('SpecialRequestSummary');

    function field(name) {
      var el = form && form.querySelector('[name="contact[' + name + ']"]');
      return el ? el.value.trim() : '';
    }

    function summary() {
      var marbleValue = field('Marble');
      if (marbleValue === 'Other') marbleValue = 'Other, ' + field('Other marble');
      var lines = [
        '*AUREMAR · SPECIAL REQUEST*',
        '',
        '*Name:* ' + field('Name'),
        '*Phone:* ' + field('Phone'),
        '',
        '*Piece:* ' + field('Piece'),
        '*Requested size:* H ' + field('Height cm') + ' × W ' + field('Width cm') +
          ' × L ' + field('Length cm') + ' cm',
        '*Marble:* ' + marbleValue
      ];
      if (field('email')) lines.push('*Email:* ' + field('email'));
      if (field('Notes')) lines.push('*Notes:* ' + field('Notes'));
      if (field('Reference design')) lines.push('*Reference photo:* attached with this message');
      if (field('Standard size')) lines.push('', 'Standard size: ' + field('Standard size'));
      lines.push('Please confirm the price for this custom size.');
      return lines.join('\n');
    }

    function showReview(on) {
      if (!preview) return;
      preview.hidden = !on;
      if (reviewBtn) reviewBtn.hidden = on;
      if (sendBtn) sendBtn.hidden = !on;
      if (editBtn) editBtn.hidden = !on;
      if (on && summaryEl) summaryEl.textContent = summary();
    }

    if (reviewBtn) {
      reviewBtn.addEventListener('click', function () {
        if (!form.reportValidity()) return;
        var pieceField = form.querySelector('[name="contact[Piece]"]');
        if (
          pieceField &&
          pieceField.value.indexOf('attach its image') > -1 &&
          !document.getElementById('SpecialRequestDesignFlag').value
        ) {
          var warn = document.getElementById('SpecialRequestDesignRequired');
          if (warn) {
            warn.hidden = false;
            warn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
          return;
        }
        showReview(true);
        preview.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
    if (editBtn) editBtn.addEventListener('click', function () { showReview(false); });

    // Reference design: previewed locally so the customer can see what they
    // picked. The file itself is attached by them in the chat or the email, 
    // Shopify's contact form cannot carry an upload.
    var designWrap = document.getElementById('SpecialRequestDesign');
    var designImg = document.getElementById('SpecialRequestDesignImg');
    var designName = document.getElementById('SpecialRequestDesignName');
    var designFlag = document.getElementById('SpecialRequestDesignFlag');
    var designClear = document.getElementById('SpecialRequestDesignClear');
    var designHint = document.getElementById('SpecialRequestDesignHint');
    var designFile = null;

    srModal.querySelectorAll('input[data-design]').forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file || file.type.indexOf('image/') !== 0) return;
        if (designImg.src) URL.revokeObjectURL(designImg.src);
        designFile = file;
        designImg.src = URL.createObjectURL(file);
        designName.textContent = file.name;
        designWrap.hidden = false;
        designFlag.value = 'Yes, photo sent with the request';
      });
    });

    var designCameraBtn = srModal.querySelector('[data-design-camera]');
    if (designCameraBtn) {
      designCameraBtn.addEventListener('click', function () {
        if (!window.AuremarCamera) return;
        window.AuremarCamera.open(function (file) {
          if (designImg.src) URL.revokeObjectURL(designImg.src);
          designFile = file;
          designImg.src = URL.createObjectURL(file);
          designName.textContent = file.name;
          designWrap.hidden = false;
          designFlag.value = 'Yes, photo sent with the request';
        });
      });
    }

    if (designClear) {
      designClear.addEventListener('click', function () {
        if (designImg.src) URL.revokeObjectURL(designImg.src);
        designFile = null;
        designImg.removeAttribute('src');
        designWrap.hidden = true;
        if (designHint) designHint.hidden = true;
        designFlag.value = '';
        srModal.querySelectorAll('input[data-design]').forEach(function (i) { i.value = ''; });
      });
    }

    var wa = document.getElementById('SpecialRequestWhatsApp');
    if (wa) {
      wa.addEventListener('click', function () {
        if (!form || !form.reportValidity()) return;
        var text = summary();
        var link = 'https://wa.me/' + wa.dataset.phone + '?text=' + encodeURIComponent(text);

        // A wa.me link carries text only. Where the browser can share files we
        // hand over the message and the photo together, so the reference image
        // actually travels with the request.
        if (designFile && navigator.canShare && navigator.canShare({ files: [designFile] })) {
          navigator
            .share({ files: [designFile], text: text, title: 'AUREMAR · Special Request' })
            .catch(function (err) {
              if (err && err.name === 'AbortError') return;
              window.open(link, '_blank', 'noopener');
            });
          return;
        }

        // Otherwise save the photo so it is one attach away rather than lost.
        if (designFile) {
          var a = document.createElement('a');
          a.href = designImg.src;
          a.download = designFile.name || 'auremar-reference.jpg';
          a.click();
          if (designHint) designHint.hidden = false;
        }
        window.open(link, '_blank', 'noopener');
      });
    }
  }

  // Shopify's contact form redirects back with ?contact_posted=true; reopen the
  // modal so the customer sees the confirmation rather than a silent reload.
  if (srModal && window.location.search.indexOf('contact_posted=true') !== -1) setModal(true);
})();
